module.exports = __webpack_public_path__ + "img/song-tea_banner.b44ba61e.jpg";